import React, {Component, Fragment} from 'react'
import {connect} from "react-redux";
import PaymentMethodFormComponent from "../PaymentMethods/PaymentMethodFormComponent";
import {selectAccountInfo} from "../../../selectors";
import Loader from "../../../components/common/Spinners/Loader";

export class OneTimePaymentComponent extends Component {

    state = {
        paymentFormDisplayed: false,
        hideLoader: false,
    }

    componentDidMount() {
        if (!this.state.paymentFormDisplayed) {

            const { accountInfo, paymentAmount, accountId} = this.props;
            const data = { iframe: true, paymentAmount: paymentAmount};
            const { guestOrderConfig } = window;

            data.submitType = "managePaymentMethods";
            if (guestOrderConfig && guestOrderConfig.defaultLocationId) {
                data.locationId = guestOrderConfig.defaultLocationId;
            } else {
                console.warn("No default location ID");
            }

            data.accountId = accountId;
            this.setState({paymentFormDisplayed: true});

            const callCreate = () => {
                if (this.paymentMethodFormRef.current && typeof this.paymentMethodFormRef.current.createPaymentMethod === 'function') {
                    this.paymentMethodFormRef.current.createPaymentMethod(data);
                }
            };
            if (this.paymentMethodFormRef.current) {
                callCreate();
            } else {
                setTimeout(callCreate, 0);
            }
        }
    }

    constructor(props) {
        super(props);
        this.paymentMethodFormRef = React.createRef();
    }

    handleStripeCheckoutOpened = () => {
        this.setState({hideLoader: true});
    }

    render() {
        const { accountInfo, paymentAmount, accountId } = this.props;
        const { hideLoader } = this.state;

        return (
            <div className="cp-form">
                <div className="card-product">
                    <div className="card-body">
                        {!hideLoader && (
                            <>
                                <Loader/>
                                <iframe
                                    name="payment_method_frame"
                                    frameBorder="0"
                                    style={
                                        {
                                            position: 'relative',
                                            zIndex: 0,
                                            display: 'block',
                                            width: '100%',
                                            minHeight:'1030px',
                                            marginTop: '-111px',
                                            borderRadius: '0.5rem'
                                        }
                                    }>
                                </iframe>
                            </>
                        )}

                        <PaymentMethodFormComponent
                            ref={this.paymentMethodFormRef}
                            accountInfo={accountInfo}
                            accountId={accountId}
                            formTarget="payment_method_frame"
                            togglePreventPanelClosing={this.props.togglePreventPanelClosing}
                            preventPanelClosing={this.props.preventPanelClosing}
                            paymentFormSubmitted = {false}
                            isOneTimePayment = {true}
                            onStripeCheckoutOpened={this.handleStripeCheckoutOpened}
                        />

                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    // const { accountInfo } = selectAccountInfo(state);

    return {

    };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(OneTimePaymentComponent);
